// This file was auto-generated using scripts/generate-icons.js
import type { JSX } from 'preact';

export type ArrowLeftIconProps = JSX.SVGAttributes<SVGSVGElement>;

/**
 * Icon generated from arrow-left.svg
 */
export default function ArrowLeftIcon(props: ArrowLeftIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      aria-hidden="true"
      viewBox="0 0 16 16"
      data-component="ArrowLeftIcon"
      {...props}
    >
      <g fill-rule="evenodd">
        <path fill="none" d="M0 0h16v16H0z" />
        <path
          fill="currentColor"
          d="M7.707 3.293a1 1 0 0 1 .083 1.32l-.083.094L5.415 7H13a1 1 0 0 1 .117 1.993L13 9H5.415l2.292 2.293a1 1 0 0 1 .083 1.32l-.083.094a1 1 0 0 1-1.32.083l-.094-.083-4-4a1 1 0 0 1-.083-1.32l.083-.094 4-4a1 1 0 0 1 1.414 0"
        />
      </g>
    </svg>
  );
}
